<template>
  <div >
    <p>جست و جو</p>
    <div class="">
      <b-form-input
          @keypress.enter.prevent="search"
          v-model="searchWords"
          placeholder="جستجو"
      ></b-form-input>
      <span @click="clearOrderProductFilter()" class="btn btn-primary m-1">حذف فیلتر محصول</span>
    </div>
    <div class="border p-1 rounded" style="overflow-y: auto; height: 300px">
      <p @click="orderProductFilter(item)" v-for="item in products">
        {{ item.name }}
      </p>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "ProductFilter",
  data() {
    return {
      searchWords: '',
    }
  },
  computed: {
    ...mapGetters({
      products: "Product/getProducts"
    })
  },
  methods: {
    search() {
      const form = {words: this.searchWords}
      console.log('in', form)
      this.$store.dispatch('Product/searchProduct', {key: 'product', form})
    },
    orderProductFilter(item) {
      this.$store.commit("ShoppingCart/setFilters", {key: "product", value: item.id});
      this.$store.dispatch('ShoppingCart/getAllOrders', 1)
    },
    clearOrderProductFilter() {
      this.$store.commit("ShoppingCart/setFilters", {key: "product", value: ''});
      this.$store.dispatch('ShoppingCart/getAllOrders', 1)
    }
  },
  mounted() {
  }
}
</script>

<style scoped>

</style>